export const akiles = {
  connectTitle: "Connect your Akiles account",
  connectHelp: "We'll take you to Akiles to authorise your organisation. No key to copy.",
  connect: "Connect to Akiles",
  opening: "Opening…",
  notConfigured: "Akiles isn't configured on the server yet. Contact support.",
  connectedTo: "Connected to",
  test: "Test",
  testing: "Testing…",
  disconnect: "Disconnect",
  mappingTitle: "Which group opens each unit",
  mappingHelp: "In Akiles, access goes through groups, and each group already covers the doors the guest needs (street door, floor, their room). Pick the group for each one.",
  commonEntrance: "Common entrance",
  none: "Unassigned",
  save: "Save",
  saving: "Saving…",
  loading: "Loading…",
  noGroups: "Your Akiles organisation has no groups. Create them in Akiles and come back.",
  pickOne: "Pick at least one group.",
  noUrl: "Akiles didn't return a connection URL.",
  genericError: "The operation could not be completed.",
  commonEntranceHelp: "Doors everyone uses (street door, garage, pool…)",
  unitHelp: "Its own door, plus anything else it needs",
  pick: "Pick a group",
  addMore: "Add another",
  remove: "Remove",
  saved: "Saved",
};
